import React from 'react';

const DependencyIn = ({
  color,
  height,
  width,
}: {
  color?: string;
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      width={width ?? 20}
      height={height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.1667 4.16667L4.1667 6.91294L6.91297 6.91294L6.91297 4.16667L4.1667 4.16667ZM3.75003 2.5C3.05967 2.5 2.50003 3.05964 2.50003 3.75L2.50003 7.32961C2.50003 8.01996 3.05967 8.57961 3.75003 8.57961L6.96024 8.57961L6.96024 11.7898C6.96024 12.4802 7.51988 13.0398 8.21024 13.0398L11.4204 13.0398V16.25C11.4204 16.9404 11.9801 17.5 12.6704 17.5H16.25C16.9404 17.5 17.5 16.9404 17.5 16.25V12.6704C17.5 11.98 16.9404 11.4204 16.25 11.4204H13.0398L13.0398 8.2102C13.0398 7.51984 12.4802 6.9602 11.7898 6.9602L8.57964 6.9602L8.57964 3.75C8.57964 3.05964 8.01999 2.5 7.32964 2.5L3.75003 2.5ZM8.62691 8.62686L8.6269 11.3731L11.3732 11.3731L11.3732 8.62686L8.62691 8.62686ZM13.0871 15.8333V13.0871H15.8334V15.8333H13.0871Z"
        fill={color ? color : '#6E6B8C'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.0438 12.4605C6.36924 12.7859 6.36924 13.3136 6.0438 13.639L4.82459 14.8582L6.0438 16.0774C6.36924 16.4028 6.36924 16.9305 6.0438 17.2559C5.71836 17.5814 5.19073 17.5814 4.86529 17.2559L3.05682 15.4475C2.90054 15.2912 2.81274 15.0792 2.81274 14.8582C2.81274 14.6372 2.90054 14.4252 3.05682 14.2689L4.86529 12.4605C5.19073 12.135 5.71836 12.135 6.0438 12.4605Z"
        fill={color ? color : '#6E6B8C'}
      />
    </svg>
  );
};

export default DependencyIn;
